'use strict';exports.__esModule = true;var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _OMFiltersTitle = require('./OMFiltersTitle.scss');var _OMFiltersTitle2 = _interopRequireDefault(_OMFiltersTitle);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMFiltersTitle = function OMFiltersTitle(properties) {var _cx;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMFiltersTitle2.default.wrapper, properties.className, (_cx = {}, _cx[_OMFiltersTitle2.default.mobile] = properties.isMobile, _cx)) },
      _react2.default.createElement('span', { className: _OMFiltersTitle2.default.iconWrapper }, _react2.default.createElement('i', { className: 'icon icon-' + properties.icon })),
      _react2.default.createElement('span', { className: _OMFiltersTitle2.default.label }, properties.label)));};exports.default =



OMFiltersTitle;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMFiltersTitle/OMFiltersTitle.js
// module id = 2758
// module chunks = 0